<template>
    <div class="sidebar">
        <div class="side_header" @click="goDashboard">
            <b>中怡新材</b>
        </div>
        <div class="side_menu">
            <el-menu background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :default-active='$route.path' :default-openeds='openeds'
             router>
                <template v-for="(item, index) in member.menus">
                    <el-submenu :index="index+1+''" :key="index">
                        <template slot="title">
                            <i class="iconfont" :class="item.icon"></i>
                            <span>{{item.title}}</span>
                        </template>
                        <template v-for="itm in item.children">
                            <template v-if="itm.url">
                                <el-menu-item :index="itm.url" :key="itm.url">{{itm.title}}</el-menu-item>
                            </template>
                            <template v-else>
                                <el-submenu :index="itm.title" :key="itm.title" class="second-submenu">
                                    <template slot="title">
                                        <span>{{itm.title}}</span>
                                    </template>
                                    <template v-for="menu in itm.children">
                                        <el-menu-item :index="menu.url" :key="menu.url">{{menu.title}}</el-menu-item>
                                    </template>
                                </el-submenu>
                            </template>
                        </template>
                    </el-submenu>
                </template>
            </el-menu>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    export default {
        name: 'sidebar',
        data() {
            return {
                openeds: ['1','2','3','4','5','6'],
                menus: []
            }
        },
        computed: {
            ...mapState([
                'member'
            ])
        },
        methods: {
            goDashboard() {
                this.$router.push('/dashboard');
            }
        }
    }
</script>

<style scoped>
    .sidebar{width: 100%;text-align: center;position: relative;height: 100%;display: flex;flex-direction: column;}
    .side_header{height: 60px;background-color: #1876EF;color: #fff;font-size: 18px;cursor: pointer;display: flex;align-items: center;justify-content: center;}
    .side_header b{padding-left: 5px;}
    .side_menu i{font-size:18px;color:#fff;width:28px;text-align:center;}
</style>
